import type { Comparison } from "../content/comparisons";

interface ComparisonRowProps {
  comparison: Comparison;
}

export function ComparisonRow({ comparison }: ComparisonRowProps) {
  return (
    <div className="comparison">
      <div className="comparison__col comparison__col--today">
        <span className="comparison__label">{comparison.today.label}</span>
        <h3 className="comparison__title">{comparison.today.title}</h3>
        <p className="comparison__body">{comparison.today.body}</p>
        <div className="comparison__visual">
          <div className="comparison__chips">
            {comparison.today.chips.map((c) => (
              <span key={c} className="comparison__chip">
                {c}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="comparison__col comparison__col--neuro">
        <span className="comparison__label">{comparison.neuro.label}</span>
        <h3 className="comparison__title">{comparison.neuro.title}</h3>
        <p className="comparison__body">{comparison.neuro.body}</p>
        <div className="comparison__visual">
          <div className="comparison__chips">
            {comparison.neuro.chips.map((c) => (
              <span key={c} className="comparison__chip">
                {c}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
